import React, { useEffect, useState } from 'react';
// import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { getRandomStr, roundNum } from '../../../helpers';
// import { formatTableValue, hasPremiumAccess } from '../../../helpers/utils';
import { dataConstants } from '../../../constants';
// import Pagination from '@mui/material/Pagination';
import TableToolbar from './TableSearch'
import EnhancedTableHead from './TableHead'
import TablePaginationActions from './TablePagination'
// import '../../../static/css/component/component-pagination-table.css'
import { formatCount } from '../../../utils/D3/helper';
// import { isMobile } from '../../../helpers/deviceDetect';
// import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { formatTableValue } from '../../../utils';
// import Link from 'next/link';
// import GrufityCircularProgress from '../../_common/GrufityProgress/CircularProgress';
import { Box } from '@mui/material';
// import { useEffect } from 'react';
import NorthEastRoundedIcon from '@mui/icons-material/NorthEastRounded';
import { Checkbox, Menu, Skeleton } from '@mui/material';

// ------- watchlist -------

import { Link, } from '@mui/material';
import getWatchlist from "../../../../lib/watchlist/_getWatchlist";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AddToWatchlistMenu from '../../_common/AddToWatchlist';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    fontWeight: 600,
    // color: 'rgba(0, 0, 0, 0.87)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const escapeRegExp = (value) => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: '100%',
//     fontFamily: 'Ubuntu, Arial, sans-serif !important',
//   },
//   paper: {
//     width: '100%',
//     marginBottom: '16px',
//   },
//   table: {
//     minWidth: 750,
//   },
//   visuallyHidden: {
//     border: 0,
//     clip: 'rect(0 0 0 0)',
//     height: 1,
//     margin: -1,
//     overflow: 'hidden',
//     padding: 0,
//     position: 'absolute',
//     top: 20,
//     width: 1,
//   },
//   tableHeaderCell: {
//     whiteSpace: 'nowrap',
//     padding: '4px 12px 4px 12px !important',
//     fontWeight: '600 !important',
//   },
// }));

// const StyledTable = styled(Table)(({ theme }) => ({
//   '& .tickername.sector-field-ellipsis': {
//     whiteSpace: 'nowrap',
//     textOverflow: 'ellipsis',
//     width: '13rem',
//     display: 'block',
//     overflow: 'hidden',
//   },

//   '& .tickername-th ': {
//     width: '15rem',
//   },

//   '& a': {
//     textDecoration: 'none',
//     color: '#174c86'
//   },

//   '& a:hover': {
//     textDecoration: 'underline',
//   },

//   '& .MuiTableSortLabel-icon': {
//     margin: '0 !important',
//   },

//   '& .MuiTableCell-sizeSmall': {
//     fontSize: '.875rem',
//     padding: ' 6px 17px',
//   },

//   '& .row-selected td': {
//     fontWeight: '700 !important',
//   },

//   [theme.breakpoints.up("sm")]: {
//     '& thead tr .mainPeersHeader:first-child ': {
//       zIndex: '0',
//     },

//     '& thead tr th:first-child, tbody tr td:first-child': {
//       position: 'sticky',
//       left: '0',
//       zIndex: '2',
//       // background: '#fff',
//     },

//     '& thead tr th:first-child': {
//       zIndex: '3',
//     },

//     '& thead tr th': {
//       zIndex: '1',
//       background: '#fbfbfc',
//       // color: '#707070',
//       color: '#000',
//       borderBottom: '1px solid #eae9ee !important',
//       // borderTop: '1px solid #eae9ee !important',
//       fontWeight: '600 !important',
//       borderRadius: "0"
//     },
//   },
// }));

const StyledTable = styled(Table)(({ theme }) => ({
  '& .tickername.sector-field-ellipsis': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '8rem',
    display: 'block',
    overflow: 'hidden',
  },

  '& .industryName-ellipsis': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '6.5rem',
    display: 'block',
    overflow: 'hidden',
  },

  '& .shortName-th ': {
    width: '7rem',
  },

  '& a': {
    textDecoration: 'none',
    color: '#174ea6'
  },

  '& a:hover': {
    textDecoration: 'underline',
  },

  '& .industryName-th': {
    width: '6.5rem',
  },

  '& .MuiTableSortLabel-icon': {
    margin: '0 !important',
  },

  '& .MuiTableCell-sizeSmall': {
    fontSize: '.875rem',
    padding: ' 6px 12px',
  },

  '& .row-selected td': {
    fontWeight: '700 !important',
  },

  // '& thead tr .MuiTableCell-root.shortName-th, thead tr .MuiTableCell-root.MKTCAP-th, thead tr .MuiTableCell-root.RETURNS1095-th, thead tr .MuiTableCell-root.PCHG__180-th, thead tr .MuiTableCell-root.PE-th, thead tr .MuiTableCell-root.NETINCTTMPCHG1Y-th, thead tr .MuiTableCell-root.ROE-th, thead tr .MuiTableCell-root.EBITDA_MGN-th, thead tr .MuiTableCell-root.ASSETS-th, thead tr .MuiTableCell-root.PMT_DIV_TTM-th, thead tr .MuiTableCell-root.DRAWDN-th, thead tr .MuiTableCell-root.TO_ASSET-th': {
  //   borderLeft: '1px solid #eae9ee',
  // },

  // '& tbody tr .MuiTableCell-root.shortName, tbody tr .MuiTableCell-root.MKTCAP, tbody tr .MuiTableCell-root.RETURNS1095, tbody tr .MuiTableCell-root.PCHG__180, tbody tr .MuiTableCell-root.NETINCTTMPCHG1Y, tbody tr .MuiTableCell-root.PE, tbody tr .MuiTableCell-root.ROE, tbody tr .MuiTableCell-root.EBITDA_MGN, tbody tr .MuiTableCell-root.ASSETS, tbody tr .MuiTableCell-root.PMT_DIV_TTM, tbody tr .MuiTableCell-root.DRAWDN, tbody tr .MuiTableCell-root.TO_ASSET': {
  //   borderLeft: '1px solid #eae9ee',
  // },

  // '& .MuiTableCell-root.Fundamentals:first-child': {
  //   borderLeft: '1px solid #000 !important',
  // },

  '& .MuiTableCell-root.tickername, .MuiTableCell-root .industry-ellipsis, .MuiTableCell-root .sector-ellipsis': {
    maxWidth: '100px',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
  },

  '& .MuiTableCell-root.ticker': {
    width: '77px',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
  },

  // '& thead tr .MuiTableCell-root.name-th, tbody tr .MuiTableCell-root.name': {
  //   borderRight: '1px solid #eae9ee !important',
  // },

  '& thead tr': {
    textAlign: 'center !important',
  },

  '& thead tr .mainPeersHeader': {
    borderRight: '1px solid #eae9ee',
    borderTop: '1px solid #eae9ee',
    borderBottom: '1px solid #eae9ee',
  },

  '& thead tr .mainPeersHeader:last-child': {
    borderRight: '0',
    // borderTop: '0',
  },

  '& thead tr .mainPeersHeader:first-child ': {
    // borderTop: '0',
  },

  '& thead tr th:nth-child(2), tbody tr td:nth-child(2)': {
    position: 'sticky',
    left: '0',
    zIndex: '4',
    // background: '#fff',
  },

  [theme.breakpoints.up("sm")]: {
    '& thead tr .mainPeersHeader:first-child ': {
      zIndex: '0',
    },

    '& thead tr th:nth-child(2), tbody tr td:nth-child(2)': {
      position: 'sticky',
      left: '0',
      zIndex: '4',
      // background: '#fff',
    },

    '& thead tr th:nth-child(2)': {
      zIndex: '3',
    },

    '& thead tr th': {
      zIndex: '1',
      background: '#fbfbfc',
      // color: '#707070',
      color: '#000',
      borderBottom: '1px solid rgb(229, 234, 242) !important',
      fontWeight: '600 !important',
    },
    '& .deleteWatchlistItem .deleteRow': {
      color: '#999'
    },
    '& tbody tr:hover .deleteWatchlistItem .deleteRow': {
      color: 'hsl(235deg 59.62% 21.27%)' /*#020B4A*/
    },
    '& .MuiTypography-caption': {
      fontSize: '.875rem'
    }
  },
}));

const EnhancedTable = ({
  wrapperClass,
  shortWrapperClass,
  tableClass,
  headCells,
  defaultHeadCells,
  rows,
  noOfRows,
  quickSearch,
  fullToolbarAccess,
  // isLoginRedirect,
  // login,
  createSections,
  // sectionOrder,
  needToolbar,
  fieldToSort,
  handleLinkClick,
  mainHeadCols,
  history,
  maxHeight,
  isLoading,
  searchPosAbsolute,
  // tabCode,
  // sectionBGColor,
  // sectionColor,
  // sectioBorderColor,

  // Presets,
  // getSectors,
  // sectorRows,
  // sectors,
  // handleTableCheckbox,
  // setMarketCap,
  // marketCap,
  // defaultSectorTableCols,
  // sectorTableCols,
  estimatedResults,
  // handleConditionDelete,
  // filters,
  // addToDefaultSectorTableCols,
  // selectedRows,
  // selected,
  // defaultFilter,
  // handleChildCheckbox,
  // defaultSectorFilters,
  // csvHeader,
  // condition,
  // conditions,
  // handleTableChipDelete,
  // setConditions,
  // setNewCondition,
  // SectorFilters,
  // setLoading,
  setOffset, offset, mounted,
  menu, tableName, setTableCols, manageColumns, saveSector,
  download, results, isPremium, setBanner, user, _watchlists
  // isLoading,
}) => {
  // const classes = useStyles();
  const sortOrderBy = headCells && headCells.length ? headCells.find(d => d?.class === 'sorted') : '';
  const sortOrderByField = sortOrderBy && sortOrderBy ? sortOrderBy.field : '';
  const [sectorTableRows, setSectorTableRows] = React.useState(rows);
  const [sectorTableCols, setSectorTableCols] = React.useState(defaultHeadCells);

  const [order, setOrder] = React.useState('asc');
  //So I always have an initial reference point, we'll just hang onto the order
  const [headCellsOrder, setHeadCellsOrder] = React.useState(
    new Array(sectorTableCols?.length).fill(null)?.map((n, i) => i)
  );
  const [orderBy, setOrderBy] = React.useState(sortOrderBy ? sortOrderByField : '');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(noOfRows ? parseInt(noOfRows) : 25);
  const [rowsPerPage, setRowsPerPage] = React.useState(noOfRows ? parseInt(noOfRows) : (rows && rows.length ? rows.length : 25));
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);
  const [dense, setDense] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const rowsPerPageOptions = rows?.length <= 30 ? [10, { value: -1, label: 'All' }] : [10, 25, 50, { value: -1, label: 'All' }];
  const [sortedCells, setSortedCells] = React.useState(fieldToSort);

  const [watchlists, setWatchlists] = useState([]);
  const [_ticker, setTicker] = useState("");
  const [contextMenu, setContextMenu] = React.useState(null);

  // const [mounted, setMounted] = React.useState(false)

  // if (!mounted) {
  //     // Code for componentWillMount here
  //     // This code is called only one time before intial render
  // }

  useEffect(() => {
    setSectorTableCols(defaultHeadCells)
  }, [defaultHeadCells])

  // const onReorderEnd = React.useCallback(
  //     ({ oldIndex, newIndex, collection, isKeySorting }, e) => {
  //         onColReorderEnd(oldIndex, newIndex, collection, isKeySorting);
  //         onRowReorderEnd(oldIndex, newIndex, collection, isKeySorting);
  //     }
  // );

  const onReorderEnd = React.useCallback(
    ({ oldIndex, newIndex, collection, isKeySorting }, e) => {
      const newOrder = [...sectorTableCols];
      const moved = newOrder.splice(oldIndex, 1);
      newOrder.splice(newIndex, 0, moved[0]);
      setSectorTableCols(newOrder);
      setTableCols(newOrder)
    },
    [sectorTableCols, setSectorTableCols]
  );
  // const onColReorderEnd = (oldIndex, newIndex, collection, isKeySorting) => {
  //     const newOrder = [...sectorTableCols];
  //     const moved = newOrder.splice(oldIndex, 1);
  //     newOrder.splice(newIndex, 0, moved[0]);
  //     setSectorTableCols(newOrder);
  // }

  // const onRowReorderEnd = (oldIndex, newIndex, collection, isKeySorting) => {
  //     const newOrder = [...sectorTableRows];
  //     const moved = newOrder.splice(oldIndex, 1);
  //     newOrder.splice(newIndex, 0, moved[0]);
  //     setSectorTableRows(newOrder);
  // }
  // const onRowReorderEnd = React.useCallback(
  //     ({ oldIndex, newIndex, collection, isKeySorting }, e) => {
  //         const newOrder = [...sectorTableRows];
  //         const moved = newOrder.splice(oldIndex, 1);
  //         newOrder.splice(newIndex, 0, moved[0]);
  //         setSectorTableRows(newOrder);
  //     },
  //     [sectorTableRows, setSectorTableRows]
  // );


  const requestSearch = (searchValue) => {
    setPage(0);
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows = rows.filter((row) => {
      return Object.keys(row).some((field) => {
        return row[field] ? searchRegex.test(row[field].toString()) : null;
      });
    });
    setSectorTableRows(filteredRows);
  };

  React.useEffect(() => {
    setSectorTableRows(rows);
  }, [rows]);

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const getComparator = (order, orderBy) => {
    return order === 'asc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const handleSortedCells = (event, property) => {
    // const isAsc = orderBy === property && order === 'asc';
    // setOrder(isAsc ? 'desc' : 'asc');
    setSortedCells(property);
  };

  // This method is created for cross-browser compatibility, if we don't
  // need to support IE11, we can use Array.prototype.sort() directly
  const stableSort = (array, comparator) => {
    const stabilizedThis = array && array.length > 0 ? array?.map((el, index) => [el, index]) : null;
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  }

  const handleClick = (event, sortOrderByField) => {
    const selectedIndex = selected?.indexOf(sortOrderByField);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, sortOrderByField);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected?.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(
        selected?.slice(0, selectedIndex),
        selected?.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows?.map((n) => n.sortOrderByField);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onLinkClick = (link, tabCode) => {
    if (link) {
      history.push(link, history.location.pathname)
      tabCode && handleLinkClick(dataConstants.STOCK_TABS.SUM)
    }
    window.location.reload()
  }

  const handleContextMenu = (event, ticker) => {
    setTicker(ticker)
    // event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
        }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
        // Other native context menus might behave different.
        // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
        null,
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  // useEffect(() => {
  //   setWatchlists(_watchlists)
  // }, [_watchlists])

  const _get_watchlist_ = async (accessToken) => {
    if (accessToken) {
      await getWatchlist(accessToken).then(data => {
        const { getWatchlist } = data || {}
        return setWatchlists(getWatchlist ?? [])
      });
    }
  }
  useEffect(() => {
    _get_watchlist_(user?.accessToken)
    // if (user?.accessToken) {
    //   await getWatchlist(user?.accessToken).then(data => {
    //     const { getWatchlist } = data || {}
    //     return setWatchlists(getWatchlist ?? [])
    //   });
    // }
  }, [user?.accessToken])

  return (
    <Box component="div" sx={{
      width: '100%', fontFamily: 'Ubuntu, Arial, sans-serif !important',
      bgcolor: '#fbfbfc', boxShadow: 0, borderRadius: '5px', pt: 1, border: 1, borderColor: 'rgb(229, 234, 242)', borderRadius: '7px',
      '& .sector-table-container::-webkit-scrollbar': {
        width: '7px',
        height: '7px',
      },
      '& .pagination-toolbar::-webkit-scrollbar': {
        width: '7px',
        height: '3px',
      },
      '& .sector-table-container::-webkit-scrollbar-track, .pagination-toolbar::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '& .sector-table-container::-webkit-scrollbar-thumb, .pagination-toolbar::-webkit-scrollbar-thumb': {
        background: 'rgba(2, 14, 74, 0.42)',
        borderRadius: '0px',
      },
      '& .sector-table-container::-webkit-scrollbar-thumb:hover, .pagination-toolbar::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(2, 11, 74, 0.67)',
      },
    }}>
      {quickSearch &&
        <TableToolbar
          // classes={classes}
          value={searchText}
          onChange={(event) => requestSearch(event.target.value)}
          clearSearch={() => requestSearch('')}
          searchPosAbsolute={searchPosAbsolute}
          // getSectors={getSectors}
          // setLoading={setLoading}
          // setMarketCap={setMarketCap}
          // marketCap={marketCap}
          // isLoading={isLoading}
          // estimatedResults={estimatedResults}
          // conditions={conditions}
          // SectorFilters={SectorFilters}
          // Presets={Presets}
          results={results}
          menu={menu}
          tableName={tableName}
          manageColumns={manageColumns}
          saveSector={saveSector}
          download={download}
          pagination={needToolbar ?
            fullToolbarAccess ?
              <TablePagination
                rowsPerPageOptions={sectorTableRows?.length >= rowsPerPage ? rowsPerPageOptions : [10]}
                component="div"
                className="pagination-toolbar"
                colSpan={3}
                count={sectorTableRows?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={(props) => <TablePaginationActions {...props} setOffset={setOffset} offset={offset} estimatedResults={estimatedResults} />}
              /> :
              <TablePagination
                sx={{
                  color: 'rgb(67, 65, 102)',
                  '& .MuiTablePagination-selectLabel, .MuiInputBase-root.MuiInputBase-colorPrimary': { display: 'none' },
                  '& .table-pagination': { ml: { md: '20px', xs: '6px', sm: '2px' } }
                }}
                // rowsPerPageOptions={sectorTableRows?.length >= rowsPerPage ? rowsPerPageOptions : [10]}
                rowsPerPageOptions={!isPremium ? [25] : [10, 25, 50, 100]}
                component="div"
                className="pagination-toolbar"
                colSpan={3}
                count={sectorTableRows?.length}
                rowsPerPage={rowsPerPage}
                page={page}

                labelDisplayedRows={function defaultLabelDisplayedRows({ from, to, count }) {
                  const totalPages = Math.ceil(estimatedResults / rowsPerPage);// Calculate the total number of pages
                  const startResult = page * rowsPerPage + 1;// Calculate the range of results currently displayed
                  const endResult = Math.min((page + 1) * rowsPerPage, estimatedResults);
                  return `Showing ${startResult} – ${endResult} of ${estimatedResults} results: Page ${page + 1} of ${totalPages}`;
                  // return `Showing ${from} – ${to} of ${count !== -1 ? `${count} result${count <= 1 ? '' : 's'}` : `more than ${to}`}`;
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={(props) => <TablePaginationActions {...props} setOffset={setOffset} offset={offset} estimatedResults={estimatedResults} setPage={setPage} isPremium={isPremium} setBanner={setBanner} isLoading={isLoading} />}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
              />
            : null}
        />}

      <TableContainer className={`${wrapperClass}-container`} sx={{ maxHeight: mainHeadCols ? { xs: 540, md: maxHeight || undefined } : (maxHeight || undefined) }}>
        <StyledTable
          // #434166
          sx={{ minWidth: 750, '& td': { fontSize: '.875rem', color: '#000' }, '& .MuiTableCell-sizeSmall.sorted': { bgcolor: 'rgba(255,255,0,.1) !important' } }}
          className={`${`${wrapperClass}-tbl` || ''} ${`${tableClass}` || ''}`}
          size="small"
          aria-label="a dense table"
          // aria-label="sticky table"
          stickyHeader
          // style={{ minWidth: 0 }}
          // aria-label="sticky table"
          id="sector-table"
        >
          {(sectorTableRows?.length <= 0 || sectorTableRows?.err?.message) && !isLoading ? null :
            <EnhancedTableHead
              // classes={classes}
              wrapperClass={wrapperClass}
              numSelected={selected?.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows?.length}
              headCells={headCells}
              value={searchText}
              onChange={(event) => requestSearch(event.target.value)}
              clearSearch={() => requestSearch('')}
              handleSortedCells={handleSortedCells}
              mainHeadCols={mainHeadCols}
              onReorderEnd={onReorderEnd}
              sectorTableCols={sectorTableCols}
            />}
          <TableBody>
            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
              rows.slice().sort(getComparator(order, orderBy)) */}
            {isLoading && Array(10).fill()?.map((row, index) => <TableRow hover key={getRandomStr(3)} sx={{ bgcolor: '#fff', borderBottom: '1px solid rgb(229, 234, 242)', '&:nth-of-type(even)': { backgroundColor: '#f5f8fb21', }, }}>
              {headCells.map(() => <TableCell key={getRandomStr(3)} component="td" scope="row"><Skeleton animation="wave" /></TableCell>)}</TableRow>)}
            {!createSections && !isLoading &&
              stableSort(sectorTableRows, getComparator(order, orderBy))
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.filter((v, i, a) => a.findIndex(t => (JSON.stringify(t) === JSON.stringify(v))) === i)
                ?.map((row, index) => {
                  const rowID = `enhanced-table-${index}`;
                  const label = `add-to-watchlist-${index}`;
                  const selectRow = row['activeRow'] ? 'row-selected' : '';
                  const ticker = row['ticker'];
                  const following = watchlists?.some((item) => {
                    const tickers = JSON.parse(item.tickers);
                    return tickers.includes(ticker);
                  });
                  return (
                    <TableRow
                      hover
                      // onClick={(event) => handleClick(event, row[sortOrderByField])}
                      tabIndex={-1}
                      key={getRandomStr(3)}
                      className={`${selectRow || ''}`}
                      sx={{
                        bgcolor: '#fff',
                        borderBottom: '1px solid rgb(229, 234, 242)',
                        '&:nth-of-type(even)': {
                          backgroundColor: '#f5f8fb21',
                        },
                        // '&:last-child td, &:last-child th': { border: 0, borderRadius: '0 0 8px 8px' }
                      }}
                      role="checkbox"
                      aria-checked={following}
                    >
                      <LightTooltip title={following ? `` : `Add to watchlist`} placement="bottom-end" followCursor disableInteractive>
                        <TableCell key={getRandomStr(3)} padding="checkbox" sx={{ background: '#fbfbfc' }}>
                          <Checkbox
                            aria-describedby={"enhanced-table"}
                            sx={{ color: 'rgb(128,134,139)', '&:hover, &:hover.Mui-checked': { color: '#174ea6' }, '&.Mui-checked': { color: 'rgb(128,134,139)' } }}
                            size="small"
                            checked={following}
                            onClick={(e) => handleContextMenu(e, ticker)}
                            icon={<AddCircleOutlineRoundedIcon />} checkedIcon={<CheckCircleRoundedIcon />}
                            inputProps={{
                              'aria-labelledby': label,
                            }}
                          />
                        </TableCell>
                      </LightTooltip>
                      {sectorTableCols && sectorTableCols.length > 0 && sectorTableCols.map(c => {
                        // if (c?.isPremium && !hasPremiumAccess(login, isLoginRedirect)) {
                        // if (!isPremium && c?.isPremium && !user) {
                        //   return (
                        //     <TableCell key={getRandomStr(3)} className={`${c.class === 'sorted' ? '' : (c.class || '')} font-weight-bold text-left`} component="td" id={rowID} >
                        //       <Link target="_blank" href={`${dataConstants.NAVS.PRICING}`} sx={{ color: '#174ea6 !important' }}>
                        //         Premium
                        //       </Link>
                        //     </TableCell>)
                        // } else {
                        if (c?.isPct) {
                          const classField = c?.field ? c?.field.replace(/[^\w\s]/gi, '') : '';
                          return (
                            c?.isPct && c?.tooltip ?
                              <LightTooltip title={c?.tooltip} placement="bottom-end" followCursor disableInteractive>
                                <TableCell key={getRandomStr(3)} className={` text-uppercase ${classField === orderBy ? 'sorted' : ''} ${classField || ''}`} component="td" id={rowID} scope="row" >
                                  <Typography variant='caption' sx={{ color: (row[c.field] * 100) < 0 ? '#D82748' : 'inherit' }}> {c.mult ? (row[c?.field] ? `${roundNum(row[c?.field] * c.mult)}%` || '' : '-') : (row[c?.field] ? `${roundNum(row[c?.field])}%` || '' : '-')}</Typography>
                                </TableCell>
                              </LightTooltip>
                              :
                              <TableCell key={getRandomStr(3)} className={` text-uppercase ${classField === orderBy ? 'sorted' : ''} ${classField || ''}`} component="td" id={rowID} scope="row" >
                                <Typography variant='caption' sx={{ color: (row[c.field] * 100) < 0 ? '#D82748' : 'inherit' }}> {c?.mult ? (row[c?.field] ? `${roundNum(row[c?.field] * c.mult)}%` || '' : '-') : (row[c?.field] ? `${roundNum(row[c?.field])}%` || '' : '-')}</Typography>
                              </TableCell>
                          )
                        } else if (c?.urlField) {
                          const classField = c?.field ? c?.field.replace(/[^\w\s]/gi, '') : '';
                          return (
                            <LightTooltip title={row[c?.field]} placement="bottom-end" followCursor disableInteractive>
                              <TableCell
                                sx={{ '&:hover .blank': { display: 'inline' }, '& .tickername.sector-field-ellipsis, .sector-field-ellipsis': { whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block', overflow: 'hidden', color: 'text.link', cursor: 'pointer' }, '&.ticker': { bgcolor: '#fbfbfc' }, bgcolor: '#fbfbfc' }}
                                key={getRandomStr(3)}
                                // title={formatTableValue(row[c?.field]) || ''}
                                className={`${c?.class || ''} text-uppercase ${classField === orderBy ? 'sorted' : ''} ${classField || ''}`} component="td" id={rowID} scope="row"
                              >
                                <a target="_blank" href={c?.urlField === 'ticker' ? `${dataConstants.NAVS.STOCK}/${row[c?.urlField]}` : `${dataConstants.NAVS.FUNDS}/${row[c?.urlField]}`} style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                  <Typography variant="caption" className={`${shortWrapperClass}-ellipsis ${c?.field}`}>
                                    {row[c?.field] ? formatTableValue(row[c?.field]) : '-'}
                                  </Typography>
                                  <NorthEastRoundedIcon className="blank" fontSize='small' sx={{ color: '#174ea6', fontSize: '.9rem', position: 'absolute', right: 0, background: '#fbfbfc', display: 'none' }} />
                                </a>
                              </TableCell>
                            </LightTooltip>)
                        } else if (c?.peerValue || c?.isSectorValue) {
                          const classField = c?.field ? c?.field.replace(/[^\w\s]/gi, '') : '';
                          return (
                            <TableCell key={getRandomStr(3)}
                              // title={formatTableValue(row[c?.field]) || ''}
                              className={` text-uppercase ${classField === orderBy ? 'sorted' : ''} ${classField || ''}`} component="td" id={rowID} scope="row" >
                              {(c?.peerValue || c?.isSectorValue) && c?.tooltip ?
                                <LightTooltip title={c?.tooltip} placement="bottom-end" followCursor disableInteractive>
                                  <Typography variant="caption" component="div" className={`${c?.field}-ellipsis text-nowrap`}>
                                    {/* {row[c?.field] ? formatCount(Math.sign(row[c?.field]) * row[c?.field], true, 1, Math.sign(row[c?.field])) : '-'} */}
                                    {row[c?.field] ? formatCount(Math.sign(row[c?.field]) * row[c?.field], true, 1, Math.sign(row[c?.field])) : '-'}
                                    {/* {row[c?.field] && formatCount(Math.sign(row[c?.field]) * row[c?.field], true, 1, Math.sign(row[c?.field]))} */}
                                  </Typography>
                                </LightTooltip>
                                :
                                <Typography variant="caption" component="div" className={`${c?.field}-ellipsis text-nowrap ${c?.field}`}>
                                  {row[c?.field] ? formatCount(Math.sign(row[c?.field]) * row[c?.field], true, 1, Math.sign(row[c?.field])) : '-'}
                                </Typography>}
                            </TableCell>)
                        } else if (c?.field.toLowerCase() === 'industry' || c?.field.toLowerCase() === 'sector') {
                          const classField = c?.field ? c?.field.replace(/[^\w\s]/gi, '') : '';
                          return (
                            <TableCell key={getRandomStr(3)}
                              className={` text-uppercase ${classField === orderBy ? 'sorted' : ''} ${classField || ''}`} component="td" id={rowID} scope="row" >
                              <LightTooltip title={row[c?.field]} placement="bottom-end" followCursor disableInteractive>
                                <Typography variant="caption" component="div" className={`${c?.field}-ellipsis text-nowrap`}>
                                  {row[c?.field] ? row[c?.field] : '-'}
                                </Typography>
                              </LightTooltip>
                            </TableCell>)
                        } else {
                          const classField = c?.field ? c?.field.replace(/[^\w\s]/gi, '') : '';
                          return (
                            <TableCell key={getRandomStr(3)}
                              // title={formatTableValue(row[c?.field]) || ''}
                              className={` text-uppercase ${classField === orderBy ? 'sorted' : ''} ${classField || ''}`} component="td" id={rowID} scope="row" >
                              <Typography variant="caption" component="div" className={`${c?.field}-ellipsis text-nowrap ${c?.field}`}>
                                {row[c?.field] ? formatTableValue(row[c?.field]) : '-'}
                              </Typography>
                            </TableCell>)
                        }
                        // }
                      })
                      }
                    </TableRow>
                  )
                })
            }
            {/* {isLoading &&
              <TableRow className="w-100" sx={{ height: '15rem' }}>
                <TableCell key={getRandomStr(3)} colSpan={headCells?.length > defaultHeadCells?.length ? headCells?.length : defaultHeadCells?.length} className="text-center border-0 loading">
                  <GrufityCircularProgress />
                </TableCell>
              </TableRow>} */}
            {/* {sectorTableRows?.length <= 0 && !mounted &&
              <TableRow sx={{ height: '15rem' }}>
                <TableCell key={getRandomStr(3)} sx={{ textAlign: 'center' }} colSpan={headCells?.length > defaultHeadCells?.length ? headCells?.length : defaultHeadCells?.length} className="text-center border-0 no-data">
                  <p className="mt-2" style={{ color: '#777', fontSize: '.875rem' }}>Loading...</p>
                </TableCell>
              </TableRow>} */}
            {(sectorTableRows?.length <= 0 || sectorTableRows?.err?.message) && !isLoading &&
              <TableRow sx={{ height: '15rem' }}>
                <TableCell key={getRandomStr(3)} sx={{ textAlign: 'center', borderBottom: '1px solid rgb(229, 234, 242)' }} colSpan={headCells?.length > defaultHeadCells?.length ? headCells?.length : defaultHeadCells?.length} className="text-center border-0 no-data">
                  <ErrorOutlineRoundedIcon sx={{ fontSize: 40, color: 'rgb(237, 108, 2)' }} />
                  {/* <p className="mt-2" style={{ color: '#bd1414', fontSize: '.875rem' }}>{marketCap.length <= 0 ? `Select atleast one market capitalization.` : `Your filters are too strict.`}</p> */}
                  <p className="mt-2" style={{ color: '#434166' }}>
                    {sectorTableRows?.err?.message ? sectorTableRows?.err?.message : `No results found. Consider selecting a different industry.`}
                  </p>
                </TableCell>
              </TableRow>}
            {/* {emptyRows > 0 && needToolbar && (
              <TableRow style={{ height: (dense ? 25 : 25) * emptyRows }}>
                <TableCell key={getRandomStr(3)} colSpan={headCells?.length > defaultHeadCells?.length ? headCells?.length : defaultHeadCells?.length} />
              </TableRow>
            )} */}
          </TableBody>
        </StyledTable>
      </TableContainer>
      <TablePagination
        sx={{ color: 'rgb(67, 65, 102)', '& .MuiTablePagination-displayedRows, .MuiTablePagination-actions': { display: 'none' } }}
        rowsPerPageOptions={!isPremium ? [25] : [10, 25, 50, 100]}
        component="div"
        className="pagination-toolbar"
        colSpan={3}
        count={sectorTableRows?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        SelectProps={{
          inputProps: { 'aria-label': 'rows per page' },
          native: true,
        }}
      />
      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        sx={{ '& .MuiList-padding.MuiMenu-list': { py: 0 } }}
      >
        <AddToWatchlistMenu
          ticker={_ticker}
          _watchlists={watchlists}
          setWatchlists={setWatchlists}
        />
      </Menu>
    </Box >
  );
}

export default React.memo(EnhancedTable);;
